// TODO(Babel 8): Remove this file.

var runtime = require('@babel/runtime/helpers/regeneratorRuntime')()
module.exports = runtime
